export class DataChampionPageComponent implements ng.IComponentOptions {
  public controller: any = DataChampionPageController;
  public template: string =
  `
  <div class="container container-fluid padding-2">
    <div class="row">
      <div class="col-md-12">
        <h1>Data Champion</h1>
      </div>
    </div>
    <div class="row margin-bottom-40px">
      <div class="col-md-12">
        <table class="table table-hover table-bordered">
          <tbody>
            <tr>
              <th>&nbsp;</th>
              <th>KEMENTERIAN/AGENSI&nbsp;</th>
              <th>Nama</th>
              <th>No. Telefon/ Emel</th>
            </tr>
            <tr>
              <th colspan="4" style=" text-align: center; ">KEMENTERIAN/JABATAN LUAR</th>
            </tr>
            <tr>
              <td rowspan="3">1</td>
              <td rowspan="3" style=" border-bottom: 1px solid #FFF; ">
                <p>KPM
                  <br />(Bahagian Perancangan dan Penyelarasan Dasar)
                  <br />
                  <br />
                  <br />
                </p>
              </td>
              <td>Dr. Guan Eng Chan</td>
              <td>03-8870 5077
                <br />guan@moe.gov.my
              </td>
            </tr>
            <tr>
              <td>Suaibatul Aslamiah Binti Abd Halim</td>
              <td>03-8870 5074
                <br />suaibatul.halim@moe.gov.my
              </td>
            </tr>
            <tr>
              <td>Mashitoh Binti Darus</td>
              <td>03-8870 6915
                <br />mashitoh.darus@moe.gov.my
              </td>
            </tr>
            <tr>
              <td rowspan="2">2</td>
              <td rowspan="2">KPM
                <br />(Bahagian Pendidikan dan Latihan Teknikal Vokasional)
              </td>
              <td>Khairul Nizam Bin Ismail</td>
              <td>03-8884 5234
                <br />k.nizam@moe.gov.my
              </td>
            </tr>
            <tr>
              <td>Mohd Azni Bin Abu Samah</td>
              <td>03-8884 5089
                <br />azni.samah@moe.gov.my
              </td>
            </tr>
            <tr>
              <td rowspan="4">3</td>
              <td rowspan="4">KBS
                <br />(Bahagian Dasar Sumber Manusia)
              </td>
              <td>YBhg. Dato&rsquo; Dr Hajah Wasitah Binti Haji Mohd Yusof</td>
              <td>03-8871 3133
                <br />drwasitah@kbs.gov.my
              </td>
            </tr>
            <tr>
              <td>Faridah Binti Ismail</td>
              <td>03-8871 3142
                <br />faridah.ismail@kbs.gov.my
              </td>
            </tr>
            <tr>
              <td>Izwandi Bin Idris</td>
              <td>izwandi@kbs.gov.my</td>
            </tr>
            <tr>
              <td>Mohd Zaid Bin Shamir</td>
              <td>mxzaid@kbs.gov.my</td>
            </tr>
            <tr>
              <td rowspan="2">4</td>
              <td rowspan="2">Kementerian Pembangunan Luar Bandar (KPLB)</td>
              <td>Rebecca Nur Iman Lee</td>
              <td>03-8891 2125
                <br />rebecca@rurallink.gov.my
              </td>
            </tr>
            <tr>
              <td>Norliza Binti Abd Halim</td>
              <td>0388912133
                <br />norliza@rurallink.gov.my
              </td>
            </tr>
            <tr>
              <td rowspan="5">5</td>
              <td rowspan="5">KPLB 
                <br />Majlis Amanah Rakyat (MARA)
              </td>
              <td>Jurafiza Binti Abd Rahim</td>
              <td>03-2613 2367
                <br />jurafiza@mara.gov.my
              </td>
            </tr>
            <tr>
              <td>Muhammad Hamdan Bin Abdul Ghani</td>
              <td>03-2613 4364
                <br />mhamdan@mara.gov.my
              </td>
            </tr>
            <tr>
              <td>Mohd Sahrom Bin Md Nasrudin</td>
              <td>03-2613 4713
                <br />msahrom@mara.gov.my
              </td>
            </tr>
            <tr>
              <td>Ainun Fadhilah Binti Othman</td>
              <td>03-2613 4708
                <br />ainun@mara.gov.my
              </td>
            </tr>
            <tr>
              <td>Wan Munirah Binti Wan Abdullah Sabary</td>
              <td>03-2613 4708 Ext 3621
                <br />wmunirah@mara.gov.my
              </td>
            </tr>
            <tr>
              <td rowspan="4">6</td>
              <td rowspan="4">MINDEF
                <br />Perbadanan Hal Ehwal Bekas Angkatan Tentera (PERHEBAT)
              </td>
              <td>Puan Hamidah Binti Setan</td>
              <td>03-6156 9412 Ext 1111
                <br />hamidah@perhebat.com.my
              </td>
            </tr>
            <tr>
              <td>Puan Samsiah Binti Saron</td>
              <td>03-6156 9412 Ext 1013
                <br />samsiah@perhebat.com.my
              </td>
            </tr>
            <tr>
              <td>Puan Azwita Hayu Ab Rahman</td>
              <td>03-6156 9412 Ext 1112
                <br />azwita@perhebat.com.my
              </td>
            </tr>
            <tr>
              <td>Mohd Redzuan Bin Abd Azid</td>
              <td>03-615 69412 Ext 1133
                <br />redzuan@perhebat.com.my
              </td>
            </tr>
            <tr>
              <th colspan="4" style=" text-align: center; ">KEMENTERIAN SUMBER MANUSIA</th>
            </tr>
            <tr>
              <td rowspan="2">7</td>
              <td rowspan="2">Bahagian Dasar Sumber Manusia</td>
              <td>Mohd Kuchairi Bin Abd Aziz</td>
              <td>03-8886 5155
                <br />kuchairi@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>Norhaili Binti Kamsan</td>
              <td>03-8886 5149
                <br />norhaili@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td rowspan="2">8</td>
              <td rowspan="2">Bahagian Pengurusan Maklumat</td>
              <td>Zaiti Binti Harun @ Ali</td>
              <td>03-8886 5173
                <br />zaiti@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>Nurakmar Binti Zubir</td>
              <td>03-8886 5191
                <br />nurakmar@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td rowspan="4">9</td>
              <td rowspan="4">JTKSM &amp; JobsMalaysia</td>
              <td>Mohd Rashdan Bin Abdul Rahman</td>
              <td>03-8886 5233
                <br />mdrashdan@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>Arman Syahlan Bin Mohd Anuar</td>
              <td>03- 8320 2713
                <br />arman@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>Khairul Nizam Bin Abu</td>
              <td>03- 8320 2713
                <br />nizamabu@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>Abi Hurairah Binti Razali</td>
              <td>03-8320 2713
                <br />abihur@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td rowspan="4">10</td>
              <td rowspan="4">JTK Sabah</td>
              <td>Noraini Bt Ithnin</td>
              <td>088-238755
                <br />noraini_ithnin95@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>Sarinah Bt Sarimin</td>
              <td>088-233820
                <br />sarinah.s@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>Walter Raymond</td>
              <td>walter@mohr.gov.my</td>
            </tr>
            <tr>
              <td>Sulkifli Silang</td>
              <td>sulkifli@mohr.gov.my</td>
            </tr>
            <tr>
              <td rowspan="3">11</td>
              <td rowspan="3">JTK Sarawak</td>
              <td>Jeffry Douglas Anak Wiliam Nagun</td>
              <td>082-242261
                <br />jeffry@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>Tan Hui Mien</td>
              <td>082-242261
                <br />hmtan@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>Kavitha Rajandran</td>
              <td>082-242261
                <br />kavitha@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td rowspan="4">12</td>
              <td rowspan="4">JPPM</td>
              <td>Farazeta Binti Mohd Lani</td>
              <td>03-8871 1290
                <br />farazeta@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>Azma Binti Abdul Rahman
                <br />
                <span style="display: none;">al</span>
              </td>
              <td>012-3812079
                <br />azma@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>Amira Syabana Binti Rosli</td>
              <td>03-8886 5460
                <br />amira@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>YM Engku Adlin Bin Engku Mohd Ariffin</td>
              <td>03-8886 5065
                <br />engkuadlin@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td rowspan="5">13</td>
              <td rowspan="5">JHEKS</td>
              <td>Encik Wan Zaifolludean bin Wan Zakaria</td>
              <td>03-8886 5418
                <br />wzaifolludean@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>Cik Aminah bt Musthapha</td>
              <td>03-8886 5458
                <br />aminah@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>Pn. Vijayasanthiri A/P Veeraperumal</td>
              <td>03-8886 2379
                <br />vijaya@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>Cik Nur Azema bte Hj Mohd.Khair</td>
              <td>03-8886 2371
                <br />nurazema@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>Wan Zaifolludean bin Wan Zakaria</td>
              <td>03-8886 5418
                <br />wzaifolludean@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td rowspan="3">14</td>
              <td rowspan="3">JPK</td>
              <td>Norisniwati binti Ab Rahim</td>
              <td>03-8886 2428
                <br />norisniwati@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>Anisah Binti Yaakob</td>
              <td>03-8886 2325
                <br />anisah@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>Azizah Binti Md Saleh</td>
              <td>03-8888 65520
                <br />azizah.mdsaleh@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td rowspan="3">15</td>
              <td rowspan="3">JTM</td>
              <td>Helmi Bin Abd Hamid</td>
              <td>03-8886 2470
                <br />helmi.ab@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>Aimi Ruzaini Binti Ahmad</td>
              <td>03-5161 2622 Ext 142
                <br />aimiruzaini@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>Yusmawati Binti Muhd. Yusof</td>
              <td>03-8886 6483
                <br />yusmawati@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td rowspan="3">16</td>
              <td rowspan="3">JKKP</td>
              <td>En. Abdul Rahman Bin Hassan</td>
              <td>03-8886 5343
                <br />abdulrahman@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>Muhamad Hapiz Bin Abdullah</td>
              <td>hapizabdullah@mohr.gov.my</td>
            </tr>
            <tr>
              <td>Hashimah Binti Hussain</td>
              <td>hashimah@mohr.gov.my</td>
            </tr>
            <tr>
              <td rowspan="3">17</td>
              <td rowspan="3">MP</td>
              <td>Cik Sri Rahmawati Binti Md. Mustahar Isa</td>
              <td>03-9236 5055
                <br />rahmawati@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>Rokiah Binti Ali Hassan</td>
              <td>03-9236 5045
                <br />rokiah@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>Yazrin Shazi Bin Mahlan</td>
              <td>03-9236 5000
                <br />yazrin@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td rowspan="2">18</td>
              <td rowspan="2">PSMB</td>
              <td>Muhamad Shazzwan Bin Abd Halim</td>
              <td>03-2096 4706
                <br />mshazzwan@hrdf.com.my
              </td>
            </tr>
            <tr>
              <td>Muhammad Ariff bin Ibrahim</td>
              <td>03-2096 4755
                <br />ariff@hrdf.com.my
              </td>
            </tr>
            <tr>
              <td rowspan="3">19</td>
              <td rowspan="3">PERKESO</td>
              <td>Mohd Sidek Bin Salleh</td>
              <td>03-4264 5444
                <br />sidek@perkeso.gov.my
              </td>
            </tr>
            <tr>
              <td>Siti Normie Binti Saidin</td>
              <td>03-4264 5417
                <br />normie.saidin@perkeso.gov.my
              </td>
            </tr>
            <tr>
              <td>Nurul Husna Binti Ibrahim</td>
              <td>03-4264 5387
                <br />husna.ibrahim@perkeso.gov.my
              </td>
            </tr>
            <tr>
              <td rowspan="2">20</td>
              <td rowspan="2">PTPK</td>
              <td>Syafry Noor Bin Sabaruddin</td>
              <td>03-4047 6110
                <br />syafry@ptpk.gov.my
              </td>
            </tr>
            <tr>
              <td>Mohd Zairi Bin Basirun</td>
              <td>03-4047 6120
                <br />zairi@ptpk.gov.my
              </td>
            </tr>
            <tr>
              <td rowspan="3">21</td>
              <td rowspan="3">NIOSH</td>
              <td>Mohd Rashidi Bin Rohmad</td>
              <td>03-8769 2194
                <br />mohd.rashidi@niosh.com.my
              </td>
            </tr>
            <tr>
              <td>Rohaila Bt Mohamed Rosly</td>
              <td>03-8769 2282
                <br />rohaila@niosh.com.my
              </td>
            </tr>
            <tr>
              <td>Haslinah Bt Hamid</td>
              <td>03-8769 2189
                <br />haslinah@niosh.com.my
              </td>
            </tr>
            <tr>
              <td rowspan="2">22</td>
              <td rowspan="2">MPGN</td>
              <td>Mohd Zikri Bin Idris</td>
              <td>03-8886 5152
                <br />zikri.idris@mohr.gov.my
              </td>
            </tr>
            <tr>
              <td>Elvis Edmund Emus</td>
              <td>03-8886-5038/012-3427982
                <br />elvis@mohr.gov.my
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  `;
}

export class DataChampionPageController {
  public static $inject: Array<string> = ['$anchorScroll'];
  constructor (private $anchorScroll: ng.IAnchorScrollService) {

  }

  public $onInit() {
    this.$anchorScroll();
  }
}
